//User Reducer Types

export const SET_AUTHENTICATED = 'SET_AUTHENTICATED'
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED'
export const LOADING = 'LOADING'
export const CREATE_POST = 'CREATE_POST'
export const CREATE_POST_ERROR = 'CREATE_POST_ERROR'
export const GET_RESPONSES_ERROR = 'GET_RESPONSES_ERROR'
export const GET_RESPONSES = 'GET_RESPONSES'
export const CREATE_RESPONSE = 'CREATE_RESPONSE'
export const RESPONSE_ERROR = 'RESPONSE_ERROR'
export const GET_FEED_POSTS = 'GET_FEED_POSTS'
export const GET_POSTS_ERROR = 'GET_POSTS_ERROR'
export const GET_BASIC_USER_INFO = 'GET_BASIC_USER_INFO'
export const GET_USER_INFO_OFF_POST_BY_USER_ID = 'GET_USER_INFO_OFF_POST_BY_USER_ID'
export const CREATE_USER_PROFILE = 'CREATE_USER_PROFILE'
export const STORED_USER_PROFILE = 'STORED_USER_PROFILE'
export const GET_NEW_USER_PROFILE_DATA = 'GET_NEW_USER_PROFILE_DATA'
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS'
export const GET_MASTER_POSTS = 'GET_MASTER_POSTS'
export const GET_POST_LIKES = 'GET_POST_LIKES'
